import { gql } from '@apollo/client';
import { TEAMMATE_FIELDS } from '@/graphql/queries/teammates';
import { USER_FIELDS } from '@/graphql/queries/users';
import { CLIENT_FIELDS } from '@/graphql/queries/clients';

export const USER_BY_EMAIL = gql`
    ${USER_FIELDS}

    query users($email: String) {
        users(where: { email: { _eq: $email } }) {
            ...UserFields
        }
    }
`;

export const SEARCH_SHIPPERS = gql`
    ${CLIENT_FIELDS}
    query SearchShippers($search: clients_bool_exp!) {
        shippers: clients(where: $search) {
            ...ClientFields
        }
    }
`;

// All client entities in an org, via the clients → user → organization_id relationship (clients
// doesn't expose organization_id to the user role, but users does, and business_name is selectable).
export const ORG_CLIENTS = gql`
    query OrgClients($organization_id: uuid!) {
        clients(where: { user: { organization_id: { _eq: $organization_id } } }, order_by: { business_name: asc }) {
            client_id
            business_name
        }
    }
`;
